import { useContext } from 'react';
import { ColumnHeaderContext } from '../context/ColumnHeaderContext';

export const useColumnHeaderContext = () => {
  const context = useContext(ColumnHeaderContext);
  if (!context) {
    throw new Error('useColumnHeaderContext must be used within ColumnHeaderProvider');
  }
  return context;
};
